module.exports = require("./gl.d.ts");